module.exports = __webpack_public_path__ + "1575c05cdbe87c6555578fbc1ece274a.png";


//////////////////
// WEBPACK FOOTER
// ./Res/3rd/hausplannerdev/img/top_logo.png
// module id = 1763
// module chunks = 1